import React, {useEffect} from 'react'

import MODES from 'constants/MODES'
import {searchService} from 'services'
import ProductsList from 'components/ProductsList'
import getPageSize from 'utils/getPageSize'

const pageSize = getPageSize()

const Products = ({state, handleSearch, searchValue, data, setData}) => {
  useEffect(() => {
    if (state === 'entered') handleSearch(MODES.fullSearchResults, searchValue)
  }, [state, handleSearch, searchValue, setData])

  return (
    <div className='categoryProducts'>
      <ProductsList
        loadMoreRequest={page => searchService.prosugcat(searchValue, {take: pageSize, skip: page * pageSize})}
        data={data}
        setData={setData}
        searchValue={searchValue}
      />
    </div>
  )
}

export default Products
